import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { Spin, Row, Col, Button, Select, Tooltip, Modal, Checkbox, message } from 'antd';
import { FileAddOutlined } from '@ant-design/icons';
import { find } from 'lodash';
import dayjs from 'dayjs';

import {
    loadMyActivities,
    createNewActivityItem
} from '../actions';
import * as constants from '../constants';

import NewActivityForm from './NewActivityForm';

import uistate from '../../uistate';
import common from '../../../common';
import core from '../../core';
import currentuser from '../../currentuser';
import globalappstate from '../../globalappstate';

const { AgGridWithState } = core;
const dateFormatter = (params) => {
    if (params.value) {
        return dayjs(params.value).format('DD-MM-YYYY');
    } else {
        return '';
    }
}

class MyActivitiesGrid extends Component {

    state = {
        currentEditEntity: {},
        addNewFormVisible: false,
    }

    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        this.props.loadMyActivities();
    }

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'MyActivitiesGrid', key);
    }

    refreshClicked = () => {
        this.props.loadMyActivities();
    }

    getGridCols = () => {
        let cols = [
            { key: "statusText", headerName: this.label("Status"), field: "statusText", sortable: true, filter: false, enableRowGroup: true, suppressHeaderMenuButton: true, width: 120, minWidth: 120, maxWidth: 120 },
            { key: "number", width: 110, minWidth: 110, maxWidth: 110, headerName: this.label("Number"), field: "number", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "name", headerName: this.label("Name"), field: "name", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "responsiblePersonDep", headerName: this.label("ResponsiblePersonDep"), field: "responsiblePersonDep", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "company", width: 70, headerName: this.label("Company"), field: "company", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true },
            { key: "reviewDate", width: 110, minWidth: 110, maxWidth: 110, headerName: this.label("ReviewDate"), field: "reviewDate", sortable: true, filter: true, enableRowGroup: false, suppressHeaderMenuButton: true, filter: "agTextColumnFilter", valueFormatter: dateFormatter },
            { key: "businessProcess", headerName: this.label("BusinessProcess"), field: "businessProcess", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
        ]

        return cols;
    }

    //#region Grid/Button handlers

    onCreateNewActivityClicked = () => {
        this.setState({
            currentEditEntity: {
                processingActivity: {

                    hasDataProcessor: false,
                    processingAgreement: false,
                    dpiaRequired: false
                },
                legalGrounds: [],
                informationCarriers: [],
                processedData: [],
                recipients: [],
            },
            addNewFormVisible: true,
        });
    }

    onDoubleClick = async (dataitem) => {
        this.props.history.push(`/app/processingactivities/${dataitem.idProcessingActivity}`);
    }

    //#endregion

    //#region Form handlers

    handleCancelForm = (e) => {
        this.setState({
            addNewFormVisible: false,
            currentEditEntity: {},
        });
    }

    handleAddNewActivity = async (values) => {
        const res = await this.props.createNewActivityItem(values);
        if(res > 0){
            message.success(this.label("Succes"));
        } else {
            message.error(this.label("ErrorCreatingActivity"));
        }
    }

    //#endregion

    render() {
        const loading = this.props.loadingActivities;
        const menuHeight = 45
        const gridHeight = this.props.contentHeight - menuHeight;
        const columnDefinitions = this.getGridCols();

        return (
            <div className='activities'>
                <Row className='main-toolbar' style={{ height: menuHeight }} justify='start' align='middle' gutter={8}>
                    <Col span={24} >
                        <span className='module-title'>{this.label("MyActivities")}</span>
                        <Button type="primary" icon={<FileAddOutlined />} onClick={this.onCreateNewActivityClicked} style={{ margin: 5 }} >{this.label("NewActivity")}</Button>
                    </Col>
                </Row>
                {loading ? (
                    <div className="loader-content" >
                        <Spin size="large" />
                        <p>{this.label("Loading")}</p>
                    </div>
                ) : (
                    <>
                        <AgGridWithState height={gridHeight} ShowGroupPanel={true}
                            lang={this.props.curLanguage}
                            onItemDoubleClicked={this.onDoubleClick}
                            columnDefinitions={columnDefinitions}
                            data={this.props.myactivities}
                            onRefresh={this.refreshClicked}
                            labels={this.props.labels}
                        >
                        </AgGridWithState>
                    </>
                )}

                <Modal title={this.label("AddNewModalTitle")} width='80%' destroyOnHidden={true}
                    open={this.state.addNewFormVisible}
                    footer={null}
                    onCancel={this.handleCancelForm}
                >
                    <NewActivityForm contentheight={gridHeight - 20}
                        datacontext={this.state.currentEditEntity}
                        onSave={this.handleAddNewActivity}
                        onCancel={this.handleCancelForm} />
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loadingActivities: state[constants.NAME].loadingActivities,
        myactivities: state[constants.NAME].myactivities,
        contentHeight: state[uistate.constants.NAME].contentheight,
        labels: uistate.selectors.uiLabels(state),
        curLanguage: uistate.selectors.curLanguage(state),
        currentuser: state[currentuser.constants.NAME],
        picklists: globalappstate.selectors.allPicklists(state),
    };
}

export default connect(mapStateToProps,
    {
        loadMyActivities,
        createNewActivityItem
    })(MyActivitiesGrid);